window.loginAsFormatter = function(value) {
    let html = '';
    if (value) {
        html += '<a href="'+value+'" class="login-as">';
        html += '<i class="fontawesome fas fa-arrow-right-to-bracket"></i>';
        html += '</a>';
    }
    return html;
}

